import { State, Action, StateContext, Selector, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CreateNotification, DismissNotification, DismissNotificationsForCallId, SubscribeToCallNotificationChannels, SubscribeToNotificationChannels, UnsubscribeFromNotificationChannels } from './notification.actions';
import { NotificationService } from 'app/services/notification/notification.service';
import { tap } from 'rxjs/operators';
import { append, patch, removeItem } from '@ngxs/store/operators';
import { Notification } from 'app/services/notification/notification.model';
import { CallNotificationService } from 'app/services/phone-notification/call-notification.service';

export class NotificationStateModel {
	notifications: Notification[];
}

@State<NotificationStateModel>({
	name: 'notifications',
	defaults: {
		notifications: []
	}
})

@Injectable()

export class NotificationState {

  @Selector()
	static notifications(state: NotificationStateModel) {
    return state.notifications;
  }

	constructor(
    private notificationService: NotificationService,
    private callNotificationService: CallNotificationService,
    private store: Store
  ) {}

  @Action(SubscribeToNotificationChannels)
  subscribeToNotificationChannels(_: StateContext<NotificationStateModel>, { lenderUser }: SubscribeToNotificationChannels) {
    this.notificationService.subscribeToNotifications(lenderUser);
    return this.notificationService.notifications$.pipe(tap(notification => {
      this.store.dispatch(new CreateNotification(notification));
    }));
  }

  @Action(SubscribeToCallNotificationChannels)
  subscribeToCallNotificationChannels(_: StateContext<NotificationStateModel>, { lenderUser }: SubscribeToCallNotificationChannels) {
    this.callNotificationService.subscribeToCallNotifications(lenderUser);
    return this.callNotificationService.callNotifications$.pipe(tap(notification => {
      this.store.dispatch(new CreateNotification(notification));
    }));
  }

  @Action(CreateNotification)
  createNotification(ctx: StateContext<NotificationStateModel>, { notification, rehydrate = false }: CreateNotification) {
    if (!ctx.getState().notifications.find(n => (
        (n.content === notification.content && n.type === notification.type)
        || n.id === notification.id
      ))) {
      if (notification.actions) {
        this.notificationService.bindActions(notification, rehydrate);
      }
      ctx.setState(patch({ notifications: append([{ ...notification }]) }));
    }
  }

  @Action(DismissNotificationsForCallId)
  dismissNotificationsForCallId(ctx: StateContext<NotificationStateModel>, { callId }: DismissNotificationsForCallId) {
    ctx.setState(patch({ notifications: removeItem<Notification>(n => n?.meta?.callId === callId) }));
  }

  @Action(DismissNotification)
  dismissNotification(ctx: StateContext<NotificationStateModel>, { id }: DismissNotification) {
    ctx.setState(patch({ notifications: removeItem<Notification>(n => n?.id === id) }));
  }

  @Action(UnsubscribeFromNotificationChannels)
  unsubscribeFromNotificationChannels(ctx: StateContext<NotificationStateModel>, _: UnsubscribeFromNotificationChannels) {
    ctx.patchState({ notifications: [] });
    this.notificationService.unsubscribeFromNotifications();
    this.callNotificationService.unsubscribeFromCallNotifications();
  }
}
